import {
  BellOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Button, Empty, Table } from "antd";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { colors } from "../../core/theme";
import { TableHelper } from "../../helpers/TableHelper";
import { translate } from "../../locale";
import DashServices from "../../services/DashServices";
import CellButton from "../Buttons/CellButton";
import SendNotification from "../Modals/SendNotification";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const OutRangeLogBook = ({ selectedData }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [selecteUser, setSelecteUser] = useState(null);

  const navigate = useNavigate();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });
  const [total, setTotal] = useState(0);

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-2">
          <Button
            type="link"
            size="small"
            onClick={() => {
              handleSendNotification(record.username);
            }}
          >
            <BellOutlined className="text-black" />
          </Button>
        </div>
      ),
    },
    {
      title: "Apellido",
      dataIndex: "last_name",
      key: "last_name",
      align: "center",
      render: (_, record) => (
        <CellButton
          onClick={() => navigate(`/admin/buscar-paciente/${record.username}`)}
          className="text-black hover:text-custom_primary"
        >
          {record.surname}
        </CellButton>
      ),
      sorter: { multiple: 2 },
    },
    {
      title: "Nombre",
      dataIndex: "first_name",
      key: "first_name",
      align: "center",
      render: (_, record) => (
        <CellButton
          onClick={() => navigate(`/admin/buscar-paciente/${record.username}`)}
          className="text-black hover:text-custom_primary"
        >
          {record.name}
        </CellButton>
      ),
      sorter: { multiple: 3 },
    },
    {
      title: "Fuera de rango",
      dataIndex: "out_of_range",
      key: "out_of_range",
      align: "center",
      render: (_, record) => (
        <div className="flex space-x-4 justify-center">
          {record.status === "danger" && (
            <div className="flex space-x-2 items-center">
              <span>1</span>{" "}
              <InfoCircleOutlined style={{ color: colors.custom_red }} />
            </div>
          )}
          {record.status === "warning" && (
            <div className="flex space-x-2 items-center">
              <span>1</span>{" "}
              <InfoCircleOutlined style={{ color: colors.custom_yellow }} />
            </div>
          )}
        </div>
      ),
      sorter: { multiple: 1 },
    },
  ];

  useEffect(() => {
    if (selectedData) {
      let data = {
        page_size: tableParams.pagination.pageSize,
        page_num: tableParams.pagination.current,
      };
      const sorter = TableHelper.sorter(tableParams);
      if (sorter !== null) {
        data = { ...data, order_by: sorter };
      }
      loadData(data);
    }
  }, [selectedData, JSON.stringify(tableParams)]);

  const loadData = async (data) => {
    setLoading(true);
    try {
      let response = await DashServices.OutRangeLogBook(
        selectedData.period,
        selectedData.suscription,
        "",
        data
      );
      if (response.status >= 200 && response.status < 300) {
        setData(response.data.data);
        setTotal(response.data.total_pages * tableParams.pagination.pageSize);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSendNotification = (username) => {
    setSelecteUser(username);
    setShowNotification(true);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  return (
    <>
      <Table
        rowKey={(i) => i.username}
        dataSource={data}
        columns={columns}
        loading={
          loading
            ? { indicator: antIcon, className: "text-custom_blue" }
            : false
        }
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
        pagination={{ ...tableParams.pagination, total: total }}
        onChange={handleTableChange}
      />
      <SendNotification
        patient={selecteUser}
        visible={showNotification}
        onCancel={() => setShowNotification(false)}
        onComplete={() => setShowNotification(false)}
      />
    </>
  );
};

OutRangeLogBook.propTypes = {
  selectedData: PropTypes.object.isRequired,
};

export default OutRangeLogBook;
